
export default {
  props: {
    type: {
      type: 'image' | 'multiImage' | 'slider',
      default: 'image',
    },
    alt: {
      type: String,
    },
    title: {
      type: String,
    },
    images: {
      required: true,
      type: Array,
    },
    imagesLg: {
      required: false,
    },
    videos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sliderInstance: null,
      hoverSliderInstance: null,
    };
  },
  computed: {
    firstImage() {
      try {
        return this.images[0].Src;
      } catch (error) {}

      return require(`~/assets/img/default-img.jpg`);
    },
    hoverImage() {
      try {
        return this.images[1].Src;
      } catch (error) {}

      return null;
    },
    allImages() {
      try {
        return this.images;
      } catch (error) {}

      return [];
    },
    first3Images() {
      try {
        return this.images.slice(0, 3);
      } catch (error) {}

      return [];
    },
    first3Media() {
      const media = [];
      if (this.coverVideo) {
        media.push(this.coverVideo);
      }
      if (this.images) {
        media.push(...this.images);
      }
      return media.slice(0, 3);
    },
    coverVideo() {
      if (this.videos && this.videos.length) {
        return this.videos.find((v) => v.Cover);
      }
      return null;
    },
    rowDisplay() {
      return this.$store.state.shop.categories?.rowDisplay;
    },
  },
  components: {},
  mounted() {},
  methods: {
    onSwiper(swiper) {
      this.sliderInstance = swiper;
    },
    onHoverSwiper(swiper) {
      this.hoverSliderInstance = swiper;
    },
  },
  watch: {
    rowDisplay() {
      this.$nextTick(() => {
        if (this.sliderInstance) {
          this.sliderInstance.update();
        }
        if (this.hoverSliderInstance) {
          this.hoverSliderInstance.update();
        }
      });
    },
  },
};
